var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsyncIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "unsync_icn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.886,
    height: 15.886,
    viewBox: "0 0 15.886 15.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.11,14.44v3.31",
    transform: "translate(0.949 -3.558)",
    fill: "none",
    stroke: "#f37070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M13.238,6.619a6.621,6.621,0,0,1-6.619,6.619c-3.654,0-5.884-3.68-5.884-3.68H3.727M0,6.619A6.6,6.6,0,0,1,6.619,0a8.142,8.142,0,0,1,6.619,3.68m0,0V.371m0,3.31H10.3",
    transform: "translate(1.324 1.324)",
    fill: "none",
    stroke: "#f37070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H15.886V15.886H0Z",
    transform: "translate(15.886 15.886) rotate(180)",
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H15.886V15.886H0Z",
    transform: "translate(15.886 15.886) rotate(180)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1144",
    "data-name": "Line 1144",
    x2: 12,
    y2: 12,
    transform: "translate(0.943 1.943)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1166",
    "data-name": "Line 1166",
    x2: 12,
    y2: 12,
    transform: "translate(1.943 0.943)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1165",
    "data-name": "Line 1165",
    x2: 12,
    y2: 12,
    transform: "translate(1.943 1.943)",
    fill: "none",
    stroke: "#f37070",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsyncIcn);
export default __webpack_public_path__ + "static/media/unsync_icn.748cab14227b20b4c6aef1a53cface57.svg";
export { ForwardRef as ReactComponent };